export default __webpack_public_path__ + "static/media/collection-family-orange.c54b8591.jpg";